// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterSelect2[data-v-7363fbd0] {
  border: 0 !important;
  padding: 0 !important;
}
.filterSelect2[data-v-7363fbd0] > * {
  height: 30px !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-select2-multi.vue","webpack://./np-select2-multi.vue"],"names":[],"mappings":"AACI;EACI,oBAAA;EACA,qBAAA;ACAR;ADEI;EACI,uBAAA;ACAR","sourcesContent":["\n    .filterSelect2 {\n        border: 0 !important;\n        padding: 0 !important;\n    }\n    .filterSelect2 > * {\n        height: 30px !important;\n    }\n",".filterSelect2 {\n  border: 0 !important;\n  padding: 0 !important;\n}\n.filterSelect2 > * {\n  height: 30px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
